import type { Theme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { FC } from "react";
import { Outlet } from "react-router-dom";
import { useSettings } from "../../contexts/settings-context";

import { Navbar } from "src/components/organisms/navbar";
import { Sidebar } from "src/components/organisms/sidebar";
import { Footer } from "../../components/molecules/footer";

const LayoutRoot = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: "100%",
  paddingTop: 64,
}));

const LayoutContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

export const Layout: FC = () => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));
  const { settings, saveSettings } = useSettings();

  const handlePinSidebar = (): void => {
    saveSettings({
      ...settings,
      pinSidebar: !settings.pinSidebar,
    });
  };

  return (
    <LayoutRoot>
      <Navbar />
      {!mdDown && <Sidebar onPin={handlePinSidebar} pinned={settings.pinSidebar} />}
      <LayoutContent
        sx={{
          ml: {
            lg: settings.pinSidebar ? "270px" : "73px",
          },
        }}>
        <Outlet />
        <Footer />
      </LayoutContent>
    </LayoutRoot>
  );
};
